<template>
  <section class="section-wrapper grey">
    <v-container class="home-financing-benefits-container">
      <h2>Get the most out of financing.</h2>

      <div class="content-wrapper">
        <div class="description-content">
          <div v-for="(item, index) in financingBenefits" :key="index">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>

          <router-link
            :to="{ name: 'ChooseDealType' }"
            class="default-btn green"
          >Find a Lender</router-link>
        </div>

        <img
          v-if="$vuetify.breakpoint.mdAndUp"
          src="@/modules/home/assets/app-phones.png" class="background-img"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'HomeFinancingBenefits',
  data: () => ({
    financingBenefits: [
      {
        title: 'Lenders are not a one size fit all',
        description: 'Finding the right lender is not as easy, with dozens of options, and each lender has a unique loan offering and "credit box" so getting the right solution has become increasingly challenging.',
      },
      {
        title: 'Save Time, Save Money',
        description: 'Each lender is unique. Your needs are unique. We match those two elements up to ensure you get the RIGHT financing, and on the first try.',
      },
      {
        title: 'Finance on your terms',
        description: 'We make sure you understand all of your options and make each decision with full information - putting you back in control.',
      },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.container {
  overflow-x: visible;

  .content-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    width: 100%;

    .description-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;

      width: 100%;

      @include md {
        align-items: flex-start;
        padding-right: 5%;
        width: 70%;
      }
      @include lg { width: 65%; }
    }
  }

  h2 {
    margin-bottom: 30px;
    width: 100%;
  }

  h2, h3, p {
    text-align: center;
    @include md { text-align: left; }
  }

  h3 {
    margin-bottom: 15px;
  }

  p {
    margin-bottom: 24px;
  }

  .col {
    position: relative;
  }

  .default-btn {
    margin-top: 6px;
  }
}
</style>
